module.exports = __webpack_public_path__ + "static/media/Thankyou-Bg.a2af5630.png";